import mixpanel from "mixpanel-browser";

import { ALLACCESS } from "@/consts/bundles";

interface Entitlement {
  content_bundle_id: number;
  content_bundle_name: string;
  entitlement_id: number;
}

let initialized = false;

function isEnabled(): boolean {
  return Boolean(
    globalThis.env?.ENABLE_MIXPANEL && globalThis.env?.MIXPANEL_TOKEN
  );
}

function isAllAccessUser(entitlements: Entitlement[]): boolean {
  return (
    entitlements?.some((e) => e.content_bundle_name === ALLACCESS) ?? false
  );
}

export function initForAllAccessUser(
  entitlements: Entitlement[],
  email: string
): void {
  if (
    !isEnabled() ||
    initialized ||
    !isAllAccessUser(entitlements) ||
    email.toLowerCase().startsWith("ciscouauto")
  ) {
    return;
  }

  // Unmask text
  // Add route tracking
  mixpanel.init(
    globalThis.env.MIXPANEL_TOKEN as string,
    {
      persistence: "localStorage",
      record_sessions_percent: 10,
      // Privacy controls: mask all text and inputs (Mixpanel defaults, explicit for clarity)
      record_mask_all_text: false,
      record_mask_all_inputs: true,
      // Block known sensitive regions by CSS selector
      record_block_selector: "[data-sensitive]",
      debug: true,
      // autocapture.pageview hooks into the History API used by Vue Router,
      // tracking every client-side navigation automatically.
      // track_pageview only fired once at init() and did not capture SPA route changes.
      autocapture: { pageview: "full-url" },
      record_heatmap_data: true,
    } as Parameters<typeof mixpanel.init>[1]
  );

  initialized = true;
  // Capture the page active at init time, since autocapture won't fire
  // retroactively for the route that was already rendered before init() ran.
  mixpanel?.track_pageview();
  mixpanel?.identify(email.toLowerCase());
  mixpanel?.people.set({ $email: email.toLowerCase() });
}
